import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

export default function AdminLoginPage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    
    if (!password) {
      setError('Veuillez entrer le mot de passe');
      return;
    }

    // Stocker le mot de passe dans le sessionStorage
    sessionStorage.setItem('adminPassword', password);
    
    // Rediriger vers la page admin config
    navigate('/admin/config');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl text-center">
            🔐 Connexion Administrateur
          </CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">
                Mot de passe administrateur
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                placeholder="Entrez le mot de passe"
                className="w-full"
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                {error}
              </div>
            )}

            <Button type="submit" className="w-full bg-amber-600 hover:bg-amber-700">
              Se connecter
            </Button>

            <div className="text-center text-sm text-gray-600 mt-4">
              <p>Mot de passe par défaut : <code className="bg-gray-100 px-2 py-1 rounded">AdminMystere2024!</code></p>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
